import { get, post } from '../services/common/common.service';
import { commonEndPoints } from '../constants/endpoint';
import { USER_TYPE } from '../constants';

export const fetchServiceLevelType = () =>
  get(commonEndPoints.serviceLevelType);

export const fetchServiceLocation = () => get(commonEndPoints.serviceLocation);

export const fetchContactServiceOfferingAddOn = () =>
  get(commonEndPoints.contactServiceOfferingAddOn);

export const fetchShipMethod = () => get(commonEndPoints.shipMethod);

export const fetchServicePriceLevel = () =>
  get(commonEndPoints.servicePriceLevel);

export const fetchWorkOrderType = () => get(commonEndPoints.workOrderType);

export const fetchServiceResponseType = () =>
  get(commonEndPoints.serviceResponseType);

export const fetchNoteType = () =>
  get(commonEndPoints.noteType);
  
export const fetchOosCasesReviewStatus = () =>
  get(commonEndPoints.oosCasesReviewStatus);

export const fetchCaseType = () =>
  get(commonEndPoints.caseType);

export const fetchChargeCode = () =>
  get(commonEndPoints.chargeCode);

export const fetchUserPermissions = (payload) => {
  if(payload.userType === USER_TYPE.externalUser){
    return post(commonEndPoints.userPermissions, payload);
  }else if(payload.userType === USER_TYPE.internalUser){
    return post(commonEndPoints.internalUserPermissions, payload);
  }
};

export const userLoginActivity = (payload) => {
  return post(commonEndPoints.userLoginActivity, payload);
};

export const getContractHistoryTypes = () => get(commonEndPoints.getContractHistoryTypes);